import { Outlet } from "react-router-dom";
import { AppHeader } from "@/components/AppHeader";
import { BottomNav } from "@/components/BottomNav";

export function AppShell() {
  return (
    <div className="flex h-screen flex-col" style={{ background: "#FFFCF8" }}>
      <AppHeader />
      <main className="flex-1 overflow-y-auto px-4 pb-24 pt-4">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
